import axios from 'axios';
import { AppConfig } from '../config';
import { useNotificationStore } from '../store/notifications';

const api = axios.create({
  baseURL: AppConfig.API_DOMAIN,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const notificationStore = useNotificationStore();
    const message = error.response?.data?.message || error.message || 'An unexpected error occurred';
    
    // We don't necessarily want to show every 401 as an error if it's part of the auth flow
    if (error.response?.status !== 401) {
      notificationStore.showError(message);
    }
    
    return Promise.reject(error);
  }
);

export default api;
